// extracted by mini-css-extract-plugin
module.exports = {"container":"error_container__Jle9B","image":"error_image__32EZS","summary":"error_summary__2-fWB"};